import React from 'react';

function NotFound () {
  return (
    <h1>404: Not Found Page</h1>
  )
}

export default NotFound;